import * as React from 'react';
import { SVGProps } from 'react';

const IconFileVideoSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2h10v12H3V2Zm1 1v.5h.8V3H4Zm1.8 0v4.5h4.4V3H5.8Zm5.4 0v.5h.8V3h-.8Zm.8 1.5h-.8v1h.8v-1Zm0 2h-.8v1h.8v-1Zm0 2h-.8v1h.8v-1Zm0 2h-.8v1h.8v-1Zm0 2h-.8v.5h.8v-.5Zm-1.8.5V8.5H5.8V13h4.4Zm-5.4 0v-.5H4v.5h.8ZM4 11.5h.8v-1H4v1Zm0-2h.8v-1H4v1Zm0-2h.8v-1H4v1Zm0-2h.8v-1H4v1Z"
    />
  </svg>
);
export default IconFileVideoSizeS;
